import { useMemo } from "react";
import { content, transparentize, useTheme } from "@glossy";
import { chart } from "@glossy/theme";

export type Variant = "greyscale" | "chart" | "heatmap";

export function getColorsFromVariant(
  variant: Variant,
  contentColor: string,
  chartColor: string
) {
  if (variant === "greyscale") {
    return [contentColor, transparentize(0.75, contentColor)];
  } else if (variant === "heatmap") {
    return ["#ffdd00", "#c24498", "#a33dfc"];
  } else {
    return [chartColor, transparentize(0.75, chartColor)];
  }
}

export function useColors(variant: Variant, colors?: string[]) {
  const theme = useTheme();
  const contentColor = content({ theme });
  const chartColor = chart({ theme });
  return useMemo(() => {
    return colors
      ? colors
      : getColorsFromVariant(variant, contentColor, chartColor);
  }, [chartColor, colors, contentColor, variant]);
}
